import { Configuration } from 'src/app/models/configurators-2d/applications/decking-boards/configuration';
import { DeckingBoardsService } from 'src/app/services/configurators-2d/applications/decking-boards.service';
import { ConfiguratorItem } from '../configurator-item';

export abstract class DeckingBoardsConfiguratorItem extends ConfiguratorItem<Configuration, DeckingBoardsService> {
  constructor(deckingBoardsService: DeckingBoardsService) {
    super(deckingBoardsService);
  }
}
